<template>
    <div class="container-fluid relative  mt-20"> <!--xl:px-24-->
        <div class="grid grid-cols-1 relative">

            <div class="tiny-one-item">
                <div class="tiny-slide">
                    <div class="relative overflow-hidden md:py-28 py-16 h-[360px] md:h-[500px] shadow dark:shadow-gray-700 bg-[url('../../assets/images/hero/bg3.jpg')] bg-center bg-no-repeat bg-cover"> <!--m-3 rounded-3xl-->
                        <div class="absolute top-0 start-0 w-full h-full z-0 pointer-events-none overflow-hidden">
                            <iframe src="https://www.youtube.com/embed/CF1PabS3qCk?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=CF1PabS3qCk" class="absolute top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2  -translate-y-1/2 w-screen h-[56.25vw] min-h-screen min-w-[177.77vw]"></iframe>
                        </div>

                        <div class="absolute inset-0 bg-zinc-950/30"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>